import React from "react";
import styles from "./style.module.scss";
import { UIText } from "src/components/uIKit";
import { MustListBodyList } from "src/utils/types";
import { TEXT_TAGS } from "src/utils/enums";
import { Separator } from "..";
import { useIsMobile } from "src/hooks/useIsMobile";
import { images } from "src/assets/images/images";

interface MustListContentProps {
  title?: string;
  subTitle?: string;
  personalHighlightsSubTitle?: string;
  fixedHighlightsTitle?: string;
  image?: string;
  body?: string;
  bodyList?: MustListBodyList[];
  personalBodyList?: MustListBodyList[];
}

const MustListContent = ({
  title,
  subTitle,
  personalHighlightsSubTitle,
  fixedHighlightsTitle,
  image,
  body,
  bodyList,
  personalBodyList,
}: MustListContentProps) => {
  const isMobile = useIsMobile();
  return (
    <div className={styles.representativeWrapper}>
      {title && (
        <UIText
          text={title}
          tag={TEXT_TAGS.H1}
          size={isMobile ? 18 : 40}
          weight={600}
          style={styles.representativeSubTitle}
        />
      )}
      <Separator className={styles.separator} />

      {subTitle && (
        <UIText
          text={subTitle}
          size={28}
          weight={500}
          style={styles.representativeSubTitle}
        />
      )}
      {personalHighlightsSubTitle && (
        <UIText
          text={personalHighlightsSubTitle}
          size={22}
          weight={500}
          style={styles.personalHighlightsSubTitle}
        />
      )}
      {personalHighlightsSubTitle && personalBodyList && personalBodyList.length > 0 && (
        <section className={styles.personalHighlightsSection} aria-label={personalHighlightsSubTitle}>
          {personalBodyList?.map((item, index) => (
            <div key={index} className={styles.personalHighlightsItem}>
              <img
                src={images.arrowleftRound}
                alt=""
                className={styles.personalHighlightsItemIcon}
                aria-hidden="true"
              />
              <div className={styles.personalHighlightsItemContent}>
                <UIText
                  text={item.title}
                  size={18}
                  weight={400}
                  style={styles.personalHighlightsText}
                />
              </div>
            </div>
          ))}
        </section>
      )}
      <UIText
        text={fixedHighlightsTitle}
        size={22}
        weight={500}
        style={styles.personalHighlightsSubTitle}
      />
      <div>
        {bodyList &&
          bodyList.map((item, index) => (
            <div key={index} className={styles.representativeBodyList}>
              <div>
                <UIText
                  text={item.title}
                  size={18}
                  weight={400}
                  style={styles.representativeText}
                />
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default MustListContent;
